import React from "react"
import PropTypes from "prop-types"
import {
  BlogContainer,
  TitleText,
  OrangeLink,
  PostDetailsText,
  PostDescriptionContainer,
  PostDescription,
} from "./styles"

const Blog = ({ title, slug, date, description, timeToRead }) => (
  <BlogContainer>
    <header>
      <TitleText>
        <OrangeLink to={`/blog${slug}`}>{title}</OrangeLink>
      </TitleText>
      <PostDetailsText>{`${date} • ${timeToRead} min read`}</PostDetailsText>
    </header>
    <PostDescriptionContainer>
      <PostDescription
        dangerouslySetInnerHTML={{
          __html: description,
        }}
      />
    </PostDescriptionContainer>
  </BlogContainer>
)

Blog.propTypes = {
  title: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  timeToRead: PropTypes.number.isRequired,
}

export default Blog
